export const DatetimeCell = ({value, locale = []}: {value?: string | null; locale?: Intl.LocalesArgument}) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }

  const strDate = value ? `${new Date(value).toLocaleString(locale, options)}` : '-'
  const formatted = strDate.replace(',', '')
  return (
    <div data-testid="datetime-cell" className="text-sm">
      {formatted}
    </div>
  )
}
